import React from 'react';
import { FormContext } from 'react-hook-form';
import { Trans } from '@lingui/macro';
import { isEmpty } from 'lodash';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import LabelInput from '@src/components/LabelInput';
import VisibleStatusBar from '@src/components/VisibleStatusBar';

import { TalentsBanner, Text } from './styled';
import { Props } from './types';
import useForm from './useForm';
import useTalents from './useTalents';

const Screen: React.FC<Props> = ({ navigation }) => {
  const { form, handleSubmit, loading } = useForm();
  const talents = useTalents();

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <AuthenticationSendButton
          loading={loading}
          disabled={loading || !isEmpty(form.errors)}
          onPress={handleSubmit}
        >
          <Trans>Next</Trans>
        </AuthenticationSendButton>
      ),
    });
  }, [form.errors, handleSubmit, loading, navigation]);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <FormContext {...form}>
          <LabelInput
            multiple
            ListHeaderComponent={
              <>
                <Text>
                  <Trans>
                    Here we are more than 10,000 professional travel lovers
                    consist of backpackers, local guides, ...
                  </Trans>
                </Text>
                <TalentsBanner />
                <Text>
                  <Trans>Tell us about yourself</Trans>
                </Text>
              </>
            }
            name="talents"
            labels={talents.data}
          />
        </FormContext>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'SetupTalents';

export default React.memo(Screen);
